/* eslint-disable */

/** Represents an option item in the mobile-presented option sheet. */
export interface TaxWebBridgeMenuItem {
  /** The ID of the option. Used to handle a tap event for the option. */
  id?: string;
  /** The title of the option displayed to the customer. */
  title?: string;
  /** The style of the item, which determines the title color and weight. */
  style?: TaxWebBridgeMenuItemStyle;
}

/** The style of the item, which determines the title color and weight. */
export enum TaxWebBridgeMenuItemStyle {
  /** DEFAULT - The title will use the default title color per platform and regular weight. */
  DEFAULT = "DEFAULT",
  /** PRIMARY - The title will use the default title color per platform and medium weight. */
  PRIMARY = "PRIMARY",
  /** DESTRUCTIVE - The title will use a destructive title color, red, and medium weight. */
  DESTRUCTIVE = "DESTRUCTIVE",
}
